import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ComponenteToken } from "../../../../../components/ComponenteToken";
import { IconArrowBack1 } from "../../../../../icons/IconArrowBack1";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const PixieOnboardingPhone = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_welcome-pixie-mobile${currentParams}`);
  };

  return (
    <div className="screen-pixie-phone">
      <div className="corporativo-4">
        <div className="molecula-stepper">
          <div className="content-4">
            <div className="numb">
              <div className="text-wrapper-8">1</div>
            </div>

            <div className="line" />
          </div>

          <div className="div-3">
            <div className="div-3">
              <div className="numb-2">
                <div className="text-wrapper-9">2</div>
              </div>

              <div className="line" />
            </div>
          </div>

          <div className="div-3">
            <div className="div-3">
              <div className="numb-2">
                <div className="text-wrapper-9">3</div>
              </div>

              <div className="line" />
            </div>
          </div>

          <div className="div-3">
            <div className="div-3">
              <div className="numb-2">
                <div className="text-wrapper-9">4</div>
              </div>

              <div className="line" />
            </div>
          </div>

          <div className="div-3">
            <div className="div-3">
              <div className="numb-3">
                <div className="text-wrapper-10">5</div>
              </div>

              <div className="line-2" />
            </div>
          </div>

          <div className="atomo-step-final-no">
            <div className="content-5">
              <div className="element-wrapper">
                <div className="element-2">6</div>
              </div>
            </div>
          </div>
        </div>

        <div className="frame-8">
          <svg
            width={65}
            height={87}
            viewBox="0 0 65 87"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46 87L32.9261 73.3183C31.6913 72.0261 31.6913 69.9549 32.9261 68.6817L46 55L59.0739 68.6817C60.3087 69.9739 60.3087 72.0451 59.0739 73.3183L46 87Z"
              fill={colors.septimo}
            />
            <path
              d="M37.5 1.25H12.5C9.84875 1.25298 7.30694 2.3075 5.43222 4.18222C3.5575 6.05694 2.50298 8.59875 2.5 11.25V68.75C2.50298 71.4013 3.5575 73.9431 5.43222 75.8178C7.30694 77.6925 9.84875 78.747 12.5 78.75H37.5C40.1513 78.747 42.6931 77.6925 44.5678 75.8178C46.4425 73.9431 47.497 71.4013 47.5 68.75V11.25C47.497 8.59875 46.4425 6.05694 44.5678 4.18222C42.6931 2.3075 40.1513 1.25298 37.5 1.25ZM5 13.75H45V61.25H5V13.75ZM12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75ZM37.5 76.25H12.5C10.5115 76.248 8.60498 75.4572 7.19889 74.0511C5.7928 72.645 5.00199 70.7385 5 68.75V63.75H45V68.75C44.998 70.7385 44.2072 72.645 42.8011 74.0511C41.395 75.4572 39.4885 76.248 37.5 76.25Z"
              fill={colors.secundario}
            />
            <path
              d="M12.5 3.75H37.5C39.4885 3.75199 41.395 4.5428 42.8011 5.94889C44.2072 7.35498 44.998 9.26149 45 11.25H5C5.00199 9.26149 5.7928 7.35498 7.19889 5.94889C8.60498 4.5428 10.5115 3.75199 12.5 3.75Z"
              fill={colors.sexto}
            />
            <path
              d="M25 66.25C24.2583 66.25 23.5333 66.4699 22.9166 66.882C22.2999 67.294 21.8193 67.8797 21.5355 68.5649C21.2516 69.2502 21.1774 70.0042 21.3221 70.7316C21.4668 71.459 21.8239 72.1272 22.3484 72.6516C22.8728 73.1761 23.541 73.5333 24.2684 73.6779C24.9958 73.8226 25.7498 73.7484 26.4351 73.4645C27.1203 73.1807 27.706 72.7001 28.118 72.0834C28.5301 71.4667 28.75 70.7417 28.75 70C28.75 69.0054 28.3549 68.0516 27.6517 67.3484C26.9484 66.6451 25.9946 66.25 25 66.25ZM25 71.25C24.7528 71.25 24.5111 71.1767 24.3055 71.0393C24.1 70.902 23.9398 70.7068 23.8452 70.4784C23.7505 70.2499 23.7258 69.9986 23.774 69.7561C23.8223 69.5137 23.9413 69.2909 24.1161 69.1161C24.2909 68.9413 24.5137 68.8222 24.7561 68.774C24.9986 68.7258 25.2499 68.7505 25.4784 68.8452C25.7068 68.9398 25.902 69.1 26.0393 69.3055C26.1767 69.5111 26.25 69.7528 26.25 70C26.25 70.3315 26.1183 70.6495 25.8839 70.8839C25.6495 71.1183 25.3315 71.25 25 71.25Z"
              fill={colors.secundario}
            />
            <path
              d="M28.75 6.25H21.25C20.9185 6.25 20.6005 6.3817 20.3661 6.61612C20.1317 6.85054 20 7.16848 20 7.5C20 7.83152 20.1317 8.14946 20.3661 8.38388C20.6005 8.6183 20.9185 8.75 21.25 8.75H28.75C29.0815 8.75 29.3995 8.6183 29.6339 8.38388C29.8683 8.14946 30 7.83152 30 7.5C30 7.16848 29.8683 6.85054 29.6339 6.61612C29.3995 6.3817 29.0815 6.25 28.75 6.25Z"
              fill={colors.secundario}
            />
          </svg>

          <div className="frame-wrapper">
            <div className="frame-9">
              <p className="subtitle-9">
                <span className="span">
                  A validation code has been sent to&nbsp;&nbsp;
                  <br />
                </span>

                <span className="text-wrapper-11">+54 9 1122 6476</span>
              </p>
            </div>
          </div>

          <ComponenteToken
            active={false}
            atomoTimeRectangleClassName="componente-token-5"
            atomoTimeSubtitleCopyClassName="componente-token-3"
            atomoTimeSubtitleCopyClassNameOverride="componente-token-3"
            atomoTimeTimelineClassName="componente-token-4"
            buttonActive
            buttonInactive={false}
            buttonSmallEstado="inactivo"
            buttonSmallTextClassName="componente-token-6"
            buttonSmallTexto="Resend code"
            className="componente-token-input"
            default1
            error={false}
            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName="componente-token-input-instance"
            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1="componente-token-input-instance"
            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2="componente-token-input-instance"
            moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride="componente-token-input-instance"
            moleculaTokenNumbsAtomoNumbTokenDivClassName="componente-token-instance"
            moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride="componente-token-instance"
            moleculaTokenNumbsAtomoNumbTokenElementClassName="componente-token-instance"
            moleculaTokenNumbsAtomoNumbTokenElementClassName1="componente-token-instance"
            moleculaTokenNumbsAtomoNumbTokenElementClassName2="componente-token-instance"
            moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride="componente-token-instance"
            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName="componente-token-input-instance"
            moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride="componente-token-input-instance"
            moleculaTokenNumbsAtomoNumbTokenText="8"
            moleculaTokenNumbsAtomoNumbTokenText1="4"
            moleculaTokenNumbsAtomoNumbTokenText2="9"
            moleculaTokenNumbsAtomoNumbTokenText3="6"
            moleculaTokenNumbsDefaultFalseActiveClassName="componente-token-2"
          />
        </div>

        <div className="action-buttons-2">
          <div
            className="test-button-3 highlighted-button"
            onClick={handleButtonClick}
          >
            <div className="text-wrapper-12">Validate</div>
          </div>
        </div>

        <header className="header-2">
          <div className="overlap-8">
            <div className="group-10">
              <div className="group-11">
                <div className="overlap-group-4"></div>
              </div>
            </div>

            <div className="frame-11">
              <div className="icon-arrow-back-wrapper">
                <IconArrowBack1 className="icon-arrow-back-1" />
              </div>

              <div className="subtitle-10">Register Mobile number</div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};
